<div class="influenza-first-component">
  <!-- <div class="container influenza-breadcrumbs">  -->
  <div class="container">
    <div class="breadcrumbs--page-nav influenza-breadcrumbs">
      <div class="container">
        <p><a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a [routerLink]="'/overview'">{{"statictext.flu360overview" | cxTranslate}}</a>
        <span> &gt; </span><a [routerLink]="'/clinical-support'">{{"statictext.clinicalsupport" | cxTranslate}}</a> <span> &gt;
        </span><strong>{{"statictext.influenza6+" | cxTranslate}}</strong>
      </p>
    </div>
  </div>
</div>
<!-- </div> -->
@if (items | async; as item) {
  <div id="influenza-burden-65plus">
    <div class="breadcrumbs--page-nav influenza-65breadcrumbs">
      <div class="container">
        <p>
          <a routerLink="/">{{"statictext.home" | cxTranslate}}</a>
          <span> &gt; </span>
          <a routerLink="/overview">{{"statictext.flu360overview" | cxTranslate}}</a>
          <span> &gt; </span><a routerLink="/clinical-support">{{"statictext.clinicalsupport" | cxTranslate}}</a>
          <span> &gt; </span>
          <strong>{{"statictext.influenza65+" | cxTranslate}}</strong>
        </p>
      </div>
    </div>
    <div class="hero--overview" role="img" aria-label="Healthcare professional facing left"  alt="Healthcare professional facing left"
      [style.backgroundImage]="'url(' + getImage(item.media) + ')'">
      <div class="container">
        <div class="hero--overview-content">
          <img class="rectangle-down" alt="angled corner" src="../../app/../assets/images/rectangle-down.svg">
          <h1 class="text-black" [innerHTML]="item.headline"></h1>
          <p class="text" [innerHTML]="item.content"></p>
        </div>
      </div>
    </div>
    <!-- for influenza mobile -->
    @if (items | async; as item) {
      <div class="row-flex center-xs d-flex flex-row justify-content-center influenza-mobile">
        <div class="hero--overview-content-mobile hide-desktop"  [style.backgroundImage]="'url(' + getImage(item.media) + ')'">
          <div class="influenza65_TopCorner d-none">
            <img class="rectangle-down" alt="angled corner" src="../../app/../assets/images/rectangle-down.svg">
          </div>
          <img class="rectangle-down influenza-TopCorner" alt="angled corner" src="../../app/../assets/images/rectangle-down.svg">
          <div class="new_header" [innerHTML]="item.headline"></div>
          <p class="text1 mobile-text1" [innerHTML]="item.content"></p>
        </div>
      </div>
    }
  </div>
}
</div>